module.exports = {"141032100":"芝河镇","141032101":"桑壁镇","141032200":"阁底乡","141032201":"南庄乡","141032202":"打石腰乡","141032203":"坡头乡","141032204":"交口乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/141032.json
// module id = 331
// module chunks = 0